import http from '@/api/http'
import { clientDiseasesPageLimit } from '@/config/api'
import { cursorParams, type PageMeta } from '@/api/pagination'

export interface ClientDisease {
  // One sick-leave entry from GET `/diseases/clients/{client_id}` (cursor-paginated, DESCENDING by to_date).

  id: number
  // Disease record id.

  from_date: string
  // ISO 8601 datetime (midnight-UTC) when the sick-leave starts.

  to_date: string
  // ISO 8601 datetime (midnight-UTC) when the sick-leave ends (inclusive per backend contract).

  notes: string
  // Free-form notes from the backend (may be empty).
}

export interface ClientDiseasesResponse extends PageMeta {
  // Paginated list payload from GET `/diseases/clients/{client_id}`.

  items: ClientDisease[]
  // Page of disease entries for one client.
}

/**
 * Fetches a page of disease entries (sick leaves) for a single client. Same
 * cursor/limit contract as the other paginated list fetchers.
 *
 * @param clientId - Person id of the client.
 * @param cursor - Optional; pass `next_cursor` from a previous page for the next page.
 */
export async function fetchClientDiseases(
  clientId: string,
  cursor?: number,
): Promise<ClientDiseasesResponse> {
  const { data } = await http.get<ClientDiseasesResponse>(`/diseases/clients/${clientId}`, {
    params: cursorParams(clientDiseasesPageLimit, cursor),
  })
  if (import.meta.env.DEV) {
    console.log(`[fetchClientDiseases] GET /diseases/clients/${clientId} response`, data)
  }
  return data
}
